import { ExclamationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { InboxArrowDownIcon } from "@/icons/outline";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as COMPANY_ACTIONS } from "../../store/actions/companyActions";

import { XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../common/Spinner";

const ArchiveModal = ({ closeModal, modalStatus, sending, sent, org, archiveCompany, permissionSettings }) => {
	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										data-dismiss="modal"
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3
								className="block-title"
								style={{ padding: "15px 20px" }}
							>
								<ExclamationCircleIcon className="h-6 w-6 mr-3 text-white" />
								Warning
							</h3>
						</div>
						<div className="modal-body">
							<div className="clearfix"></div>
							<p>
								Archiving this account means that you are no longer able to use this account for HR &
								Payroll management. Historical data will be maintained, and you can still export data
								until this account is deleted.
							</p>
							<p>Confirm you would like to Archive this account.</p>
						</div>
						<div
							className="block-content"
							style={{ padding: "0px 20px 1px" }}
						>
							{sending && (
								<Spinner
									style={{ width: "2rem", height: "2rem", verticalAlign: "middle", marginTop: 20 }}
									className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"
								/>
							)}

							<div
								className="flex-auto buttons"
								style={{ paddingBottom: 20 }}
							>
								{!sent && (
									<button
										className="btn btn-danger pull-right"
										type="submit"
										onClick={() => {
											closeModal();
											archiveCompany(org);
											permissionSettings = "Read";
										}}
									>
										<ExclamationTriangleIcon
											className="w-7 h-7 mr-3"
											style={{ verticalAlign: "text-bottom" }}
										/>
										Yes
									</button>
								)}
								{sent && <div className="btn btn-success pull-right">Yes</div>}
								{!sent && (
									<button
										className="btn btn-success pull-left"
										type="submit"
										onClick={() => {
											closeModal();
										}}
									>
										<InboxArrowDownIcon
											className="w-7 h-7 mr-3"
											style={{ verticalAlign: "text-bottom" }}
										/>
										No
									</button>
								)}
								{sent && <div className="btn btn-success pull-left">No</div>}
								<div className="clearfix"></div>
							</div>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		modalStatus: state.company.archiveModal,
		org: state.company.settings.org,
		permissionSettings: state?.permissions?.my?.permissions?.settings,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(COMPANY_ACTIONS.setArchiveModal(false)),
	archiveCompany: (body) =>
		dispatch(COMPANY_ACTIONS.updateCompanyDetails({ org: body, status: "Archived", plan: "-" })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveModal);
